export default __webpack_public_path__ + "static/media/DENVER.8525cdd9.jpg";